import { render, staticRenderFns } from "./filt.vue?vue&type=template&id=45caac7e&lang=pug"
import script from "./filt.vue?vue&type=script&lang=js"
export * from "./filt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports